
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect } from "react";

// import { setPDPSaved } from './../../redux/pdp/pdpActions';
// import { saveProperty, unsaveProperty } from 'src/redux/saved/savedActions';
import { useSelector, useDispatch } from "react-redux";
import { currencyFormatNew } from "../pdpComponents/utils.jsx";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import * as FaIcons from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

// import ForeclosureView from "./ForeclosureView.jsx";
import {

  getCMS, getPDPInitData, getUserAction, isUserAuthorised

} from "@/api/PDP";
import "react-tooltip/dist/react-tooltip.css";


import { isValidSession } from "@/api/auth";
import { isPhoneNoVerified } from "@/api/bid";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
  setShowSessionMsg,
} from "@/redux/login/loginSlice";
import {
  setIsOtpVerificationModalRequired,
} from "@/redux/login/loginSlice";
import { sendVerificationCode } from "@/api/LoginSignup";
import { showOtpModal } from "@/redux/otpModal/otpModalSlice";
import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";
import { enableOwnItNow, setIsNDAAccepted, setOfferData, setPdpError, setRedirectionAction, setRedirectionAmount, setSelectedBidAmount, updateSaveProperty } from "@/redux/PDP/pdpSlice";
import NDAModel from "../BidCenter/NDAModel.jsx";
import { setIsAddedToSaved, showSavedTooltip } from "@/redux/savedpreference/savedPreferenceSlice.js";
import { onSavePress, onUnsavePress } from "@/api/srpFilter.js";
import PDPSaveModal from "./PDPSaveModal.jsx";
import ForeclosureView from "../BidCenter/ForeclosureView.jsx";
import { trackApiCall, trackButtonClick } from "@/utils/analytics.js";
import BidAlertTextModal from "../BidCenter/BidAlertTextModal.jsx";

const centerDivStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const GalleryBidCenter = ({
  statusPayload,
  navigation,
  pdpBidCenter,
  pdpData,
  financialType,
  listingType,
  status,
  offerType,
  offerCenterDetail,
  isSignedUser,
  isFcOnlineFlag,
  pdpPropertyFees,
  isWatchProperty,
  fullAddress,
  handleClose,
  savePropertyState,
  setSavePropertyState,
  showAlert,
  setShowAlert,
  alertText,
  setAlertText,
}) => {
  const {
    isUnderReview,
    isTraditional,
    isPreview,
    isUnderContractAuction,
    isUnderContractTraditional,
    isHNBTraditional,
    isShortSaleUnderContractAuction,
    isShortSaleUnderContractTraditional,
    isUnderReviewAuction,
    isShortSaleUnderReview,
    isForeclosure,
  } = statusPayload;

  const { propertyId, detailedAttributes, commonAttributes, address } =
    pdpData?.propertyDetails;

  const isCashOnly = financialType?.length === 1 && financialType[0] === "CASH";
  const currentSavedProperties = useSelector(
    (state) => state.saved?.savedProperties
  );
  const userData = useSelector((state) => state.auth?.registration);
  const onWatchList = useSelector((state) => state.pdp?.onWatchList);
  const user = useSelector((state) => state.user);
  const [isSaved, setIsSaved] = useState(onWatchList);

  const { propCategory } = commonAttributes;
  const { isPrelistAsset, apnTaxId, isAllowedPreSale } = detailedAttributes;
  const isPreviewProperty = isAllowedPreSale !== null;
  // const isTraditional =  listingType === "TRNL";

  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const latestBidCenterData = useSelector(
    (state) => state.pdp?.latestBidCenterData
  );
    const isNDAAccepted = useSelector((state) => state.pdp.isNDAAccepted);
    const [showNDA, setShowNDA] = useState(false);
      const auctionDetails = useSelector((state) => state.pdp.auctionDetails);
  const redirectionAmount = useSelector((state) => state.pdp?.redirectionAmount);

  const [bidActionType, setBidActionType] = useState("")

  // const featureCMSData = useSelector(state => state.featureConf.featureCMSData);

  const ownItNowEnabled = pdpInitData?.listingDetail?.ownItNowFlag;
  const countyBiddingEnabled = pdpInitData?.countyBiddingEnabled;

  const [showReserveMet, setReserveMet] = useState(false);
  const [buyerAmountInfo, setBuyerAmountInfo] = useState({});
  const isScheduled = commonAttributes?.status === 'SCHEDULED' ? true : false;
  const [showDynamicBiddingPopUp, setShowDynamicBiddingPopUp] = useState(false)
    const profileInfo = useSelector((state) => state.user.user);
    const userID = profileInfo?.realbidUserId;
      const [isVerificationGoing, setIsVerificationGoing] = useState(false);
      const [isNDAAcceptedLocal, setIsNDAAcceptedLocal] = useState(isNDAAccepted);
      // const [savePropertyState, setSavePropertyState] = useState(false);
      const [showModal, setShowModal] = useState(false);
 const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const [showOfferAlert, setShowOfferAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");


  //   const icon =
  //     isSaved && userData?.user?.userEmailId ? Icons.HeartFilled : Icons.Heart;
  const navigate = useNavigate();
  const showBid =
    isFcOnlineFlag === "Y" ||
    (propCategory !== "FORECLOSURE" &&
      isPrelistAsset !== "PREVIEW" &&
      listingType !== "TRNL");

  const isFcOnlineProp =
    isFcOnlineFlag != undefined && isFcOnlineFlag === "Y" ? true : false;
  const bidCenterData = useSelector((state) => state.pdp.bidCenterData);
  const bestBidAvailable =
    bidCenterData.bestBidAvailable && isSignedUser ? true : false;
  const undercontractOffer = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };

  const underReviewData = {
    header: pdpBidCenter?.underreview,
    content: pdpBidCenter?.underreviewdesc,
  };
  const previewData = {
    header: pdpBidCenter?.previewPropertyContent.previewPropertyHeader,
    content: pdpBidCenter?.previewPropertyContent.previewPropertyContent,
  };
  const underContractAuctionData = {
    header: pdpBidCenter?.undercontractAuction,
    content: pdpBidCenter?.undercontractdesc,
  };
  const underContractTraditionalData = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const hNBTraditionalData = {
    header: pdpBidCenter?.hnbended,
    content: pdpBidCenter?.undercontractofferhnbdesc,
  };
  const shortSaleUnderContractTraditionalData = {
    header: pdpBidCenter?.undercontractOffer,
    content: pdpBidCenter?.undercontractofferdesc,
  };
  const hasHnbData = {
    header: pdpBidCenter?.hnbended,
    content: pdpBidCenter?.undercontractofferhnbdesc,
  };
  const isShortSaleUnderContractAuctionData = {
    content: pdpBidCenter?.undercontractdescShortSale,
  };

  const fcOnlineAuctionEventEnded = {
    header: pdpBidCenter?.pdpFcOnline.auctionEventEnded,
    content: pdpBidCenter?.pdpFcOnline.auctionEventEndedSubTxt,
  };

  const beds = commonAttributes?.bedroomsNum;



  let hnbDeadlnDt = [];
  let higherstBidTerms = {};
  let date = `${hnbDeadlnDt[1]} ${hnbDeadlnDt[2]} on ${hnbDeadlnDt[0]}`;
  if (statusPayload?.hnbDeadlnDt) {
    hnbDeadlnDt = statusPayload.hnbDeadlnDt.split(" ");
    higherstBidTerms = {
      header: pdpBidCenter?.hnbrequestedtitle,
      content: pdpBidCenter?.hnbdesc?.replace("###DATE###", date),
    };
  }
  const [bidIncrementCount, setBidIncrementCount] = useState(Number(0));
    const [bidAmount, setBidAmount] = useState(
      auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount &&
        Number(auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount)
    );
  const [validationError, setvalidationError] = useState("");
  const [error, setError] = useState(null);
  const [cmsErrorMessages, setCmsErrorMessages] = useState();

  const [activeConfigData, setActiveConfigData] = useState([]);
  const [isVerificationGoingForOwnitNow, setIsVerificationGoingForOwnitNow] =
    useState(false);
      const redirectionAction = useSelector((state) => state.pdp?.redirectionAction);
  const pdpError = useSelector((state) => state.pdp.pdpError);



  //   var activeConfigData = featureCMSData?.activeBidConfig
  //   ? featureCMSData.activeBidConfig
  //   : activeConfigCms;
  // const actConfig = featureCMSData?.activeBidConfig
  //   ? featureCMSData?.activeBidConfig
  //   : activeConfigCms;

  let buttonLabel = "-";

  let nextpossibleBidAmount = 0;
  let biddingIncrementalAmount = 0;
  let incrementMultiplier = 0;
  let maximumPossibleBidAmount = 0;
  let bidMinLimit = 0;
  let bidMaxLimit = 0;
  let bidMaxLength = 0;
  let lowerThresholdAmount = 0;
  let lowerThresholdIncrementMultiplier = 0;
  let upperThresholdAmount = 0;
  let upperThresholdIncrementMultiplier = 0;
  let offerMinLimit = 0;
  let offerMaxLimit = 0;
 let customBidIncrementMultiplier = 0;
  if (bidCenterData) {
    biddingIncrementalAmount = bidCenterData?.biddingIncrementalAmount;
    customBidIncrementMultiplier = bidCenterData?.customBidIncrementMultiplier;
    incrementMultiplier = bidCenterData?.incrementMultiplier;
    maximumPossibleBidAmount = bidCenterData?.maximumPossibleBidAmount;
    nextpossibleBidAmount = auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount : latestBidCenterData.nextpossibleBidAmount;
    lowerThresholdAmount = bidCenterData?.lowerThresholdAmount;
    upperThresholdAmount = bidCenterData?.upperThresholdAmount;
    lowerThresholdIncrementMultiplier =
      bidCenterData?.lowerThresholdIncrementMultiplier;
    upperThresholdIncrementMultiplier =
      bidCenterData.upperThresholdIncrementMultiplier;
    if (
       latestBidCenterData?.highestBidAmount  >= upperThresholdAmount &&
      bidCenterData?.activeBidRefinementEnabled === true
    ) {
      bidMinLimit =
        latestBidCenterData?.highestBidAmount + upperThresholdIncrementMultiplier;
      bidMaxLimit = latestBidCenterData?.highestBidAmount + upperThresholdIncrementMultiplier;
    } else if (
       latestBidCenterData?.highestBidAmount  >= lowerThresholdAmount &&
      latestBidCenterData?.activeBidRefinementEnabled === true
    ) {
      bidMinLimit =
         latestBidCenterData?.highestBidAmount  + lowerThresholdIncrementMultiplier;

     bidMaxLimit = latestBidCenterData?.highestBidAmount + 2*(lowerThresholdIncrementMultiplier);

    } else if (
      auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount &&
          auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount > 0
    ) {


      bidMinLimit = auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
        latestBidCenterData?.nextpossibleBidAmount;
       bidMaxLimit = bidCenterData?.maximumPossibleBidAmount;



    } else {
      bidMinLimit = latestBidCenterData?.highestBidAmount + biddingIncrementalAmount;
       bidMaxLimit = bidCenterData?.maximumPossibleBidAmount;

    }
     if( latestBidCenterData?.activeBidRefinementEnabled === true && nextpossibleBidAmount <= lowerThresholdAmount){
              bidMaxLimit = lowerThresholdAmount;
    }
    // if (
    //   bidCenterData?.maximumPossibleBidAmount &&
    //   bidCenterData?.maximumPossibleBidAmount > 0
    // ) {
    //   bidMaxLimit =
    //     bidCenterData?.activeBidRefinementEnabled === true &&
    //       nextpossibleBidAmount <= lowerThresholdAmount
    //       ? lowerThresholdAmount
    //       : bidCenterData?.maximumPossibleBidAmount;
    // }
  }

  bidMaxLength = (bidMaxLimit + ' ').length + 1;
  if (pdpInitData && pdpInitData.offerCenterDetail) {
    offerMinLimit = pdpInitData.offerCenterDetail.minimumStartingOffer;
    offerMaxLimit = pdpInitData.offerCenterDetail.maximumPermissibleOffer;
  }

  const lowerSlab =
    lowerThresholdAmount > bidCenterData?.currentHighestBid
      ? lowerThresholdAmount
      : bidCenterData?.currentHighestBid + lowerThresholdIncrementMultiplier;

  const upperSlab =
    upperThresholdAmount >= auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
      latestBidCenterData?.nextpossibleBidAmount
        ? upperThresholdAmount
        : auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount;

  const [lowerSlabAmount, setLowerSlabAmount] = useState('');
  const [upperSlabAmount, setUpperSlabAmount] = useState('');
  const [slabUpdated, setSlabUpdated] = useState(false);

customBidIncrementMultiplier = incrementMultiplier;

  if (slabUpdated != true) {
    setLowerSlabAmount(lowerSlab || '');
    setUpperSlabAmount(upperSlab || '');
    setSlabUpdated(true);
  }


  const dispatch = useDispatch();
    useEffect(() => {

      if (profileInfo.primaryPhone) {
          if((!pdpError || pdpError?.length === 0) && redirectionAction){
          onSuccessfullLogin();

          }
      }
    }, [profileInfo.primaryPhone]);

   const onSuccessfullLogin = async () => {

     if (redirectionAction === "handlePlaceBid") {
       if (propCategory === 'COMMERCIAL') {
         const details = await getPDPInitData(pdpInitData?.propertyDetails?.listingId);
         if (details) {

           setIsNDAAcceptedLocal(details?.ndaCommercialAccepted);
           dispatch(setIsNDAAccepted(details?.ndaCommercialAccepted))
           dispatch(setIsCifCompletedForPACT(details?.cifCompleted));

           // setShowNDA(true);


           const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
           setIsVerificationGoing(false);
           dispatch(enableOwnItNow(false));

           if (res?.data?.data) {
             if (!(validationError?.length > 0)) {
               const isAuthorised = await isUserAuthorised(
                 pdpInitData?.propertyDetails?.listingId
               );

               if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
                 setAlertText(
                   "You cannot place another bid as you are the current highest bidder."
                 );
                 setShowAlert(true);
               } else {
                 dispatch(setSelectedBidAmount(bidAmount));


                 if (propCategory === "COMMERCIAL" && status !== "PACT") {

                   if (details?.ndaCommercialAccepted === "N") {
                     if (!document.querySelector('.modal-backdrop')) {
                   setShowNDA(true);
                       }
                     return;
                   } else if (details?.ndaCommercialAccepted === "Y") {
                     navigate("/bid");
                   }

                 } else {
                   navigate("/bid");
                 }
               }
             }
           } else {
             const isPhoneVerified = res?.data?.data;

             if (!isPhoneVerified) {
               dispatch(
                 showOtpModal({
                   phoneNumber: profileInfo?.primaryPhone,
                   redirectScreen: "PDP",
                   redirectionRequired: true,
                 })
               );
               dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
             }
           }
         }
        hanldePlaceBid(bidActionType);
       } else {
         hanldePlaceBid(bidActionType)
       }

     } if (redirectionAction === "handleOwnItNow") {
       handleOwnItNow()
     } if (redirectionAction === "placeBackUpOffer") {
       navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)
     } if (redirectionAction === "placeOffer") {
      //  placeOffer(offerCenterDetail?.listingId)
     }

     dispatch(setRedirectionAction(""));

   };


  useEffect(() => {
    getCMS(encodeURI('global/appUpdateConfig/activeBidConfig')).then(response => {
      setActiveConfigData(response?.results);
    })
    if (!cmsErrorMessages) {
      getCMS('global/errorMessages').then(response => {
        setCmsErrorMessages(response?.results[0]);

      });


    }
  }, []);

  const getData = () => {
    switch (listingType) {
      case "TRNL":
        let data = undercontractOffer;
        if (offerType === "PLACE_BACKUP_OFFER") {
          if (
            offerCenterDetail.hasHnB === "Y" &&
            offerCenterDetail.remDeadlineHrs <= 0
          ) {
            if (status !== "SPND") {
              return hNBTraditionalData;
            }
          }
          if (status !== "ACTV") {
            return data;
          }
        } else if (offerType === "WATCH_PROPERTY") {
          return {
            header: pdpBidCenter?.hnbended,
            content: pdpBidCenter?.undercontractofferhnbdescWatch,
          };
        } else if (offerType === "PLACE_OFFER") {
          return higherstBidTerms;
        }
        return data;
      case "AUCN":
        if (status === "WFA") {
          return {
            header: pdpBidCenter?.AUCN?.WFA?.biddingHeader,
            content: pdpBidCenter?.AUCN?.WFA?.description,
          };
        }
        if (status === "SPND") {
          return {
            header: pdpBidCenter?.AUCN?.SPND?.biddingHeader,
            content: pdpBidCenter?.AUCN?.SPND?.description,
          };
        }
        return "";
      default:
        if (isPreview) {
          return previewData;
        }
        if (status === "WFA") {
          return {
            header: pdpBidCenter?.isPreview?.WFA?.header,
            content: pdpBidCenter?.isPreview?.WFA?.content,
          };
        }
        return "";
    }
  };
  const getHeader = () => {

    return (
      <h3 className="text-center">
        {isUnderReviewAuction && underReviewData.header}
        {isShortSaleUnderContractTraditional &&
          shortSaleUnderContractTraditionalData.header}
        {isUnderReview && !isUnderReviewAuction && underReviewData.header}
        {isPreview && previewData.header}
        {(isUnderContractAuction || isShortSaleUnderContractAuction) &&
          isFcOnlineProp &&
          fcOnlineAuctionEventEnded.header}
        {(isUnderContractAuction || isShortSaleUnderContractAuction) &&
          !isFcOnlineProp &&
          underContractAuctionData.header}
        {isUnderContractTraditional &&
          !hasHnbData &&
          underContractTraditionalData.header}
        {isHNBTraditional && hNBTraditionalData.header}
        {hasHnbData &&
          !isHNBTraditional &&
          !isUnderReview &&
          !isPreview &&
          !isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          !isShortSaleUnderContractTraditional &&
          hasHnbData.header}
      </h3>
    );
  };

  const getContent = () => {
    return (
      <p
        size={15}
        lh={22}
        color={"black"}
        style={{ marginBottom: 10, marginLeft: 10, marginRight: 10 }}
      >
        {isUnderReview &&
          isUnderReviewAuction &&
          isShortSaleUnderReview &&
          !bestBidAvailable &&
          underReviewData.content}
        {isUnderReviewAuction &&
          !isShortSaleUnderReview &&
          bestBidAvailable &&
          pdpBidCenter?.placeBestBidLabel.underreviewBestBid}

        {isUnderReviewAuction &&
          !bestBidAvailable &&
          !isShortSaleUnderReview &&
          underReviewData.content}

        {isUnderReview &&
          !isUnderReviewAuction &&
          !bestBidAvailable &&
          underReviewData.content}
        {isPreview && previewData.content}
        {isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          isFcOnlineProp &&
          fcOnlineAuctionEventEnded.content}
        {isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          !isFcOnlineProp &&
          underContractAuctionData.content}
        {isShortSaleUnderContractAuction &&
          isUnderContractAuction &&
          isFcOnlineProp &&
          fcOnlineAuctionEventEnded.content}
        {isShortSaleUnderContractAuction &&
          isUnderContractAuction &&
          !isFcOnlineProp &&
          isShortSaleUnderContractAuctionData.content}
        {isUnderContractTraditional &&
          !hasHnbData &&
          underContractTraditionalData.content}
        {isHNBTraditional && hNBTraditionalData.content}
        {isShortSaleUnderContractTraditional &&
          shortSaleUnderContractTraditionalData.content}
        {hasHnbData &&
          !isPreview &&
          !isHNBTraditional &&
          !isUnderReview &&
          !isUnderContractAuction &&
          !isShortSaleUnderContractAuction &&
          !isShortSaleUnderContractTraditional &&
          hasHnbData.content}
      </p>
    );
  };
  const currencyConverter = (currencyValue) => {
    if (currencyValue !== undefined && currencyValue !== "") {
      if (typeof currencyValue === "string") {
        currencyValue = Number(currencyValue);
      }
      let value = currencyValue.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return "$" + value.substring(0, value.indexOf(".") + 0);
    }
    return null;
  };
  const getPrice = () => {
    let result = {
      amount: "",
      label: "",
    };


    if (listingType === "AUCN") {
      if (statusPayload.isActive || statusPayload.isPact) {
        const hasValidTimer = bidCenterData?.auctionTimeLeft !== null;
      }
      if (bidCenterData.displayListPriceForAuction === "Y") {
        result.amount = currencyConverter(bidCenterData.listingPrice);
        result.label = "Listing Price";
      } else if (bidCenterData.currentHighestBid === 0) {
        result.amount = currencyConverter(bidCenterData.startingBidAmount);
        result.label = "Starting Bid";
      } else {
        result.amount = currencyConverter(auctionDetails?.highestBidAmount ? auctionDetails?.highestBidAmount : bidCenterData?.currentHighestBid);
        result.label = "Current Highest Bid";
      }
    } else if (listingType === "TRNL") {
      if (
        offerCenterDetail?.currentHighestOffer !== "0" &&
        offerCenterDetail?.currentHighestOffer !== null
      ) {
        result.amount = currencyConverter(
          offerCenterDetail.currentHighestOffer
        );
        result.label = "Current Highest Offer";
      } else if (offerCenterDetail.listingPrice) {
        result.amount = currencyConverter(offerCenterDetail.listingPrice);
        result.label = "Listing Price";
      } else {
        result.amount = currencyConverter(pdpInitData?.propertySpecialDetails?.listingPrice);
        // result.label = 'Current Highest Bid';
        result.label = "Starting Bid";
      }
    } else if (propCategory === "FORECLOSURE") {
      if (estimatedOpeningBid) {
        result.amount = currencyConverter(estimatedOpeningBid);
        result.label = "Estimated Opening Bid";
      } else {
        result.amount = "TBD";
        // result.label = 'Starting Bid';
        result.label = "Estimated Opening Bid";
      }
    }
    // result.amount =
    //   result.amount.indexOf('$') > -1 || result.amount.indexOf('TBD') > -1
    //     ? result.amount
    //     : '$' + result.amount;
    return result;
  };

  const getCTATitle = () => {

  };
  let errorMessage = null;

  const validateBidMinMaxPriceError = () => {

    const CHB = nextpossibleBidAmount - biddingIncrementalAmount;
    if ((parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier != 0) {

      if (bidCenterData?.activeBidRefinementEnabled === true &&
        parseInt(bidAmount) === lowerThresholdAmount) {

      } else {

        if (bidCenterData?.activeBidRefinementEnabled === true &&
          bidCenterData?.currentHighestBid < lowerThresholdAmount &&
          parseInt(bidAmount) > lowerThresholdAmount) {

          errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
            "###MAX_BID_AMOUNT###",
            getFormatPrice(bidMaxLimit)
          );
          setvalidationError(
            errorMessage
          );
          dispatch(setPdpError(errorMessage))

        } else {

          errorMessage =
            "Please use $" +
            currencyFormatNew(customBidIncrementMultiplier) +
            " increments";
          setvalidationError(
            "Please use $" +
            currencyFormatNew(customBidIncrementMultiplier) +
            " increments"
          );
            dispatch(setPdpError( "Please use $" +
            currencyFormatNew(customBidIncrementMultiplier) +
            " increments"))


        }

      }

    } else if (bidAmount === 0 || bidAmount === "" || bidAmount === "$") {
      setvalidationError(cmsErrorMessages?.EMPTY_BID_AMOUNT);
      dispatch(setPdpError( cmsErrorMessages?.EMPTY_BID_AMOUNT))
      errorMessage = cmsErrorMessages?.EMPTY_BID_AMOUNT;
    } else if (Number(bidAmount) < bidMinLimit) {
      setvalidationError(
        cmsErrorMessages?.MIN_BID_AMOUNT.replace(
          "###MIN_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MIN_BID_AMOUNT.replace(
          "###MIN_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )))
      errorMessage = cmsErrorMessages?.MIN_BID_AMOUNT.replace(
        "###MIN_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      );
    }
    // else if (
    //   Number(bidAmount) > bidMaxLimit &&
    //   bidCenterData?.activeBidRefinementEnabled !== true  ////changed as part of 110 bidwizard sheer
    // ) {
    else if (
      Number(bidAmount) > bidMaxLimit
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMaxLimit)
        )
      );
      dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMaxLimit)
        )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMaxLimit)
      );
      return;
    } else if (Number(bidAmount) > maximumPossibleBidAmount) {
      setvalidationError(cmsErrorMessages?.MAX_BID_REACHED);
       dispatch(setPdpError(cmsErrorMessages?.MAX_BID_REACHED))
      errorMessage = cmsErrorMessages?.MAX_BID_REACHED;
    } else {
      setvalidationError("");
       dispatch(setPdpError(""))
      errorMessage = null;
    }

    if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      bidCenterData?.currentHighestBid >= lowerThresholdAmount &&
      latestBidCenterData?.nextpossibleBidAmount < upperThresholdAmount &&
      bidAmount > bidMinLimit + lowerThresholdIncrementMultiplier
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
        )
      );
       dispatch(setPdpError(cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
        )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
      );
    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      bidCenterData?.currentHighestBid >= upperThresholdAmount &&
      bidAmount > bidMinLimit + upperThresholdIncrementMultiplier
    ) {
      setvalidationError(
        cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )
      );
       dispatch(setPdpError( cmsErrorMessages?.MAX_BID_AMOUNT.replace(
          "###MAX_BID_AMOUNT###",
          getFormatPrice(bidMinLimit)
        )))
      errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
        "###MAX_BID_AMOUNT###",
        getFormatPrice(bidMinLimit)
      );
    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >=
      parseInt(
        lowerThresholdAmount +
        (nextpossibleBidAmount % biddingIncrementalAmount) +
        biddingIncrementalAmount
      ) &&
      nextpossibleBidAmount <=
      lowerThresholdAmount +
      (nextpossibleBidAmount % biddingIncrementalAmount)
    ) {
      /* bid amount in the border of lower threshhold  added equal to for HUBZ-3027*/
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        )
      );
      dispatch(setPdpError( "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        )))
      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(lowerSlab) +
          (nextpossibleBidAmount % biddingIncrementalAmount)
        );

    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >
      parseInt(
        upperThresholdAmount +
        (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
      ) &&
      nextpossibleBidAmount <
      upperThresholdAmount +
      (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
    ) {
      /* bid amount in the border of upper threshhold */
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        )
      );
      dispatch(setPdpError(  "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        )))

      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        );
    } else if (
      bidCenterData?.activeBidRefinementEnabled === true &&
      parseInt(bidAmount) >
      parseInt(upperSlab - upperThresholdIncrementMultiplier) +
      parseInt(upperThresholdIncrementMultiplier) *
      activeConfigData?.upperThreshHoldMaxCount
    ) {
      setvalidationError(
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab - upperThresholdIncrementMultiplier) +
          parseInt(upperThresholdIncrementMultiplier) *
          activeConfigData?.upperThreshHoldMaxCount
        )
      );
        dispatch(setPdpError(  "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab - upperThresholdIncrementMultiplier) +
          parseInt(upperThresholdIncrementMultiplier) *
          activeConfigData?.upperThreshHoldMaxCount
        )))

      errorMessage =
        "The maximum possible bid amount is $" +
        currencyFormatNew(
          parseInt(upperSlab) +
          (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        );

      // setBidAmountError(true);

    }


  };

  const getFormatPrice = (amnt) => {
    if (amnt?.length === 0 || isNaN(amnt)) {
      return "";
    }
    return amnt?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };

  const getFormattedPrice = (amount) => {
    return getFormatPrice(amount ? amount : bidAmount);
  };

  const decrement = () => {
    setvalidationError("");
    dispatch(setPdpError(""))

    if (bidAmount > bidMinLimit) {
       trackButtonClick({
        eventName: "bid_center_decrement_click",
        eventCategory: "NEW-PDP",
        eventSource: "On Decrease Icon button click",
        eventLabel: `Decrease | listingId: ${pdpInitData?.propertyDetails?.listingId}`
      })

      if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        bidCenterData?.currentHighestBid >= lowerThresholdAmount &&
        bidCenterData?.currentHighestBid < upperThresholdAmount
      ) {

        if (bidAmount > bidMaxLimit) {
         setBidAmount(parseInt(nextpossibleBidAmount));

        }else{

          const CHB = nextpossibleBidAmount - lowerThresholdIncrementMultiplier;

          const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) % parseInt(lowerThresholdIncrementMultiplier);

          if (remainder === 0) {
            setBidAmount(
              parseInt(bidAmount) - parseInt(lowerThresholdIncrementMultiplier)
            );
          } else {
            setBidAmount(parseInt(bidAmount) - remainder);

          }

          // setBidAmount(bidAmount - lowerThresholdIncrementMultiplier);
        setBidIncrementCount(bidIncrementCount - 1);
        }


      } else if (
        bidCenterData?.activeBidRefinementEnabled === true &&
        bidCenterData?.currentHighestBid >= upperThresholdAmount
      ) {

       const CHB = nextpossibleBidAmount - upperThresholdIncrementMultiplier;

           const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) % parseInt(upperThresholdIncrementMultiplier);

          if(remainder === 0){
              setBidAmount(
            parseInt(bidAmount) - parseInt(upperThresholdIncrementMultiplier)
          );
          }else{
               setBidAmount(parseInt(bidAmount) - remainder);

          }
        // setBidAmount(bidAmount - upperThresholdIncrementMultiplier);
        setBidIncrementCount(bidIncrementCount - 1);
      } else {
         const CHB = nextpossibleBidAmount - biddingIncrementalAmount;

         if ((parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier != 0) {
          const remainder = (parseInt(bidAmount) - parseInt(CHB)) % customBidIncrementMultiplier;
          setBidAmount(parseInt(bidAmount) - remainder);
        }  else if (bidAmount > bidMaxLimit) {
          setBidAmount(parseInt(nextpossibleBidAmount));
        }
        else {
          setBidAmount(parseInt(bidAmount) - parseInt(biddingIncrementalAmount));
        }
        // setBidAmount(bidAmount - biddingIncrementalAmount);
      }
    } else {
      setBidAmount(parseInt(nextpossibleBidAmount));
      // validateBidMinMaxPriceError();
    }
  };

  const increment = () => {
    setvalidationError("");
      dispatch(setPdpError(""))
    if (bidAmount < bidMaxLimit) {
      trackButtonClick({
        eventName: "bid_center_increment_click",
        eventCategory: "NEW-PDP",
        eventSource: "On Increase Icon button click",
        eventLabel: `Increase | listingId: ${pdpInitData?.propertyDetails?.listingId}`
      })

      if (
       bidCenterData?.activeBidRefinementEnabled === true &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) >= lowerThresholdAmount &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) < upperThresholdAmount
      ) {
        if (bidAmount < bidMinLimit + lowerThresholdIncrementMultiplier) {
         if (bidAmount < bidMinLimit) {
           setBidAmount(bidMinLimit);

         }else{
          const CHB = nextpossibleBidAmount - lowerThresholdIncrementMultiplier;

          const remainder =
            (parseInt(bidAmount) - parseInt(CHB)) %
            lowerThresholdIncrementMultiplier;
          const adjustment = lowerThresholdIncrementMultiplier - remainder;
          setBidAmount(parseInt(bidAmount) + adjustment);



            // setBidAmount(
            //   parseInt(bidAmount) + parseInt(lowerThresholdIncrementMultiplier)
            // );
             setBidIncrementCount(bidIncrementCount + 1);

         }
        } else {
          validateBidMinMaxPriceError();
        }
      } else if (
         bidCenterData?.activeBidRefinementEnabled === true &&
        (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
          latestBidCenterData?.nextpossibleBidAmount) >= upperThresholdAmount
      ) {
        if (
          bidIncrementCount < 0 &&
          (auctionDetails.nextpossibleBidAmount ? auctionDetails.nextpossibleBidAmount :
            latestBidCenterData?.nextpossibleBidAmount) > upperThresholdAmount
        ) {
          setBidAmount(parseInt(bidAmount) + parseInt(upperThresholdIncrementMultiplier));
          setBidIncrementCount(parseInt(bidIncrementCount) + 1);
        } else {
          validateBidMinMaxPriceError();
        }
      } else {
         if (
          bidCenterData?.activeBidRefinementEnabled === true &&
          parseInt(bidAmount) + parseInt(biddingIncrementalAmount) >
            lowerThresholdAmount
        ) {
          validateBidMinMaxPriceError();
        } else {
          if (bidAmount < bidMinLimit) {
            setBidAmount(parseInt(bidMinLimit));
          } else {
            const CHB = nextpossibleBidAmount - biddingIncrementalAmount;

            if (
              (parseInt(bidAmount) - parseInt(CHB)) %
                customBidIncrementMultiplier !=
              0
            ) {
              const remainder =
                (parseInt(bidAmount) - parseInt(CHB)) %
                customBidIncrementMultiplier;
              const adjustment = customBidIncrementMultiplier - remainder;
              setBidAmount(parseInt(bidAmount) + adjustment);
            } else {
              if (parseInt(bidAmount) < bidMinLimit) {
                setBidAmount(bidMinLimit);
              } else {
                  const remainder =
                (parseInt(bidAmount) - parseInt(CHB)) %
                biddingIncrementalAmount;
              const adjustment = biddingIncrementalAmount - remainder;
              setBidAmount(parseInt(bidAmount) + adjustment);

                // setBidAmount(
                //   parseInt(bidAmount) + parseInt(biddingIncrementalAmount)
                // );
                // amount =
                //   parseInt(bidAmount) + parseInt(biddingIncrementalAmount);
              }
            }
          }
        }

      }
    }

    else {
      validateBidMinMaxPriceError();
    }
  };


  const saveProperty = () => {
    navigate("/bid");
    //save codee
  };
    const hanldePlaceBid = async (type) => {
    if(type !=="registerCompleted"){
       if(latestBidCenterData.placeBackupBidButton !== true ){
       validateBidMinMaxPriceError();
    }
      // validateBidMinMaxPriceError();
      setBidActionType(type)
      setIsVerificationGoing(true);
      try {
         if (profileInfo?.userEmailId ) {
        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;
        const phoneNo = profileInfo?.primaryPhone;

        if (isValid === "Y") {
          trackButtonClick({
            eventName: "bid_center_place_bid_click",
            eventCategory: "NEW-PDP",
            eventSource: "on place bid button click under gallery modal",
            eventLabel: `${pdpInitData?.propertyDetails?.listingId}| Register Place Bid`
          })

          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
          setIsVerificationGoing(false);
          dispatch(enableOwnItNow(false));

          if (res?.data?.data) {
            if (!(validationError.length > 0)) {
              const isAuthorised = await isUserAuthorised(
                pdpInitData?.propertyDetails?.listingId
              );

              if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
                handleClose();
                setAlertText(
                  "You cannot place another bid as you are the current highest bidder."
                );
                setShowAlert(true);
              } else {
                dispatch(setSelectedBidAmount(bidAmount));
                if (propCategory === "COMMERCIAL" && status !== "PACT") {

                  if (isNDAAcceptedLocal === "N") {
                    setShowNDA(true);
                  } else if (isNDAAcceptedLocal === "Y") {
                    navigate("/bid");
                  }

                } else {
                  navigate("/bid");
                }
              }
            }
          } else {
            const isPhoneVerified = res?.data?.data;

            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                  redirectionRequired: true,
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
            }
          }
        } else {

          dispatch(setRedirectionAction('handlePlaceBid'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
          handleClose();

        }
      }else{
        dispatch(setRedirectionAction('handlePlaceBid'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(false))
              handleClose();
      }
      } catch (error) {
      } finally {
        setIsVerificationGoing(false);
      }
    }
    };

  const openDynamicBiddingPopUp = () => {
    setShowDynamicBiddingPopUp(true)
  }
  const navigateToBidCountySite = () => {
    //
  }

 const navigateToPlaceBackUpOffer = async (listingId) => {
    try {
      setIsVerificationGoing(true);
       if (profileInfo?.userEmailId ) {

      const isSessionValid = await isValidSession();
      const isValid = isSessionValid.data?.isValidSession;
      const phoneNo = profileInfo?.primaryPhone;
      if (isValid === "Y") {
        trackButtonClick({
          eventName: "place_backup_offer_click",
          eventCategory: "NEW-PDP",
          eventSource: "on place backup offer click",
          eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
        });

        const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
        setIsVerificationGoing(false);

        if (res?.data?.data) {
          let offerType = "PLACE_BACKUP_OFFER";

          validateUserAction(offerType, listingId);
        } else {
          const isPhoneVerified = res?.data?.data;
          const data = { phoneNo, verificationType: "sms" };
          if (!isPhoneVerified) {
            dispatch(
              showOtpModal({
                phoneNumber: profileInfo?.primaryPhone,
                redirectScreen: "PDP",
              })
            );
            dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
            const response = await sendVerificationCode(data);

            if (
              response?.status === "FAILURE" &&
              response?.errorCode.startsWith("Invalid")
            ) {
            }
          }
        }
      } else {
        dispatch(setRedirectionAction('placeBackUpOffer'));
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
           handleClose();
      }
    }else{
       dispatch(setRedirectionAction('placeBackUpOffer'));
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        dispatch(setShowSessionMsg(false))
         handleClose();
    }

    } catch (error) {
    } finally {
      setIsVerificationGoing(false);
    }
  };

  const handleRequestInformation = () => {}
  const saveTofav = () => {}
  const navigateToPlaceBackUpBid = () => {}

  const validateUserAction = async (offerType, listingId) => {
    const listingid = pdpInitData?.listingDetail?.businessListingId;
    // const offerListingId = offerCenterDetail?.listingId;
    const type = offerType === "PLACE_BACKUP_OFFER" ? "Place Backup Offer" : "Place Offer"

    trackButtonClick({
      eventName: "user_action_type_check",
      eventCategory: "NEW-PDP",
      eventSource: `on ${type} click`,
      eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
      eventParams: { action_type: type }
    })

    const response = await getUserAction(listingid);
    trackApiCall({
      eventName: "user_action_type_check_success",
      eventCategory: "NEW-PDP",
      eventSource: `on ${type} click`,
      eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
      eventParams: { action_type: type }
    })

    if (response === true) {
      setAlertTitle(
        statusPayload?.hasHnb === "Y"
          ? "Place HnB Offer"
          : "Place Counter Offer"
      );
      setShowOfferAlert(true);
    } else {
      if (offerType === "PLACE_OFFER") {
        const state = {
         listingId: listingid,
        userId: String(userID),
        offerAmount: Number(bidAmount),
        offerType: String(offerType)
        };
        dispatch(setOfferData(state))
        navigate("/offer", {
          state: state,
        });

      } else {
        const state = {
          listingId: listingid,
        userId: String(userID),
        offerAmount: Number(offerCenterDetail?.minimumStartingOffer),
        offerType: String(offerType),
        };
        dispatch(setOfferData(state))
        navigate("/offer", {
          state: state,
        });

      }
    }
  };

  const placeOffer = async (listingId) => {
    // validateOfferMinMaxPriceError();
    if (!redirectionAmount) {
      setvalidationError("Enter offer amount");
        dispatch(setPdpError("Enter offer amount"))
      setIsVerificationGoing(false);
      return;
    }
    if (!validationError) {
      try {
        setIsVerificationGoing(true);
         if (profileInfo?.userEmailId ) {
        const isSessionValid = await isValidSession();
        const isValid = isSessionValid.data?.isValidSession;

        const phoneNo = profileInfo?.primaryPhone;

        if (isValid === "Y") {
          trackButtonClick({
            eventName: "place_offer_click",
            eventCategory: "NEW-PDP",
            eventSource: "on place offer click",
            eventLabel: `listingId: ${pdpInitData?.propertyDetails?.listingId}`,
          });

          const res = await isPhoneNoVerified(profileInfo?.primaryPhone);
          setIsVerificationGoing(false);

          if (res?.data?.data) {
            let offerType = "PLACE_OFFER";

            validateUserAction(offerType, listingId);

            // let offerType = "PLACE_OFFER"

            // const state = { listingId, userId: user.user.realbidUserId, offerAmount: offerAmount, offerType }
            // navigate("/offer", {
            //   state: state,
            // });
          } else {
            const isPhoneVerified = res?.data?.data;

            const data = { phoneNo, verificationType: "sms" };

            if (!isPhoneVerified) {
              dispatch(
                showOtpModal({
                  phoneNumber: profileInfo?.primaryPhone,
                  redirectScreen: "PDP",
                })
              );
              dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
              const response = await sendVerificationCode(data);

              if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
              ) {
              }
            }
          }
        } else {

          dispatch(setRedirectionAction('placeOffer'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(true))
           handleClose();
        }
      }else{
          dispatch(setRedirectionAction('placeOffer'));
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
         dispatch(setLoginCallLocation("Popup"));
          dispatch(setShowSessionMsg(false))
           handleClose();
      }
      } catch (error) {
      } finally {
        setIsVerificationGoing(false);
      }
    }
  };

  const handleOfferAmountChange = (e) => {
    const text = e.target.value;
    if (text === '') {
      setBidAmount('');
      dispatch(setRedirectionAmount(''));
    } else {
      var amnt = text.replace('$', '')
      setBidAmount(amnt?.toString().replace(/,/g, ''));
      dispatch(setRedirectionAmount(amnt?.toString().replace(/,/g, '')));
    }
    setvalidationError('');
     dispatch(setPdpError(""))
  }

  const handleBidAmountChange = (value) => {
    const text = value;
    if (text === "") {
      setBidAmount("");
    } else {
      var amnt = text.replace("$", "");
      setBidAmount(amnt?.toString().replace(/,/g, ""));
    }
    setvalidationError("");
     dispatch(setPdpError(""))
  };
  const handleOwnItNow = async () => {
    setIsVerificationGoingForOwnitNow(true);
    try {
      const isSessionValid = await isValidSession();
      const isValid = isSessionValid.data?.isValidSession;

      const phoneNo = profileInfo?.primaryPhone;

      if (isValid === "Y") {
        const res = await isPhoneNoVerified(profileInfo?.primaryPhone);

        if (res?.data?.data) {
          dispatch(enableOwnItNow(true));
          if (!(validationError?.length > 0)) {
            const isAuthorised = await isUserAuthorised(
              pdpInitData?.propertyDetails?.listingId
            );
            setIsVerificationGoingForOwnitNow(false);

            if (isAuthorised.message === "USER_NOT_ALLOWED_TO_BID") {
              setAlertText(
                "You cannot place another bid as you are the current highest bidder."
              );
              setShowAlert(true);
            } else {
              dispatch(setSelectedBidAmount(bidAmount));
              if (propCategory === "COMMERCIAL" && isNDAAccepted === "N") {
                setShowNDA(true);
              } else {
                navigate("/bid");
              }
            }
          }
        } else {
          const isPhoneVerified = res?.data?.data;

          const data = { phoneNo, verificationType: "sms" };

          if (!isPhoneVerified) {
            dispatch(
              showOtpModal({
                phoneNumber: profileInfo?.primaryPhone,
                redirectScreen: "PDP",
              })
            );
            dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
            const response = await sendVerificationCode(data);

            if (
              response?.status === "FAILURE" &&
              response?.errorCode.startsWith("Invalid")
            ) {
            }
          }
        }
      } else {
        dispatch(setLoginModal(true));
        dispatch(setLoginTab("loginTab"));
        dispatch(setLoginCallLocation("Popup"));
        handleClose();
      }
    } catch (error) {
    } finally {
      setIsVerificationGoingForOwnitNow(false);
    }
  };
    const handleNDAClose = () => {
    setShowNDA(false);
  };
  const handleNDAccepted = () => {
    setShowNDA(false);
    navigate("/bid");
  };
    const onSave = async () => {
      const propertyId = pdpInitData?.propertyDetails?.propertyId;
      if (userEmailId || isUserSubscribed) {
        setShowModal(false)

        if (savePropertyState) {
          // dispatch(updateSaveProperty("N"));
          setSavePropertyState(false)
          const response = await onUnsavePress({ propertyId });
          if (response === "success") {
            dispatch(setIsAddedToSaved());

            trackApiCall({
              eventName: "favourite_property_unsaved",
              eventCategory: "NEW-PDP",
              eventSource: "pdp_bid_center",
              eventLabel: `Property Id: ${propertyId}`,
            });
          } else {
            trackApiCall({
              eventName: "favourite_property_unsave_error",
              eventCategory: "Error",
              eventSource: `Error - ${
                response?.message || "Data Initialization Failed"
              }`,
              eventLabel: `Property Id: ${propertyId}`,
            });
          }
        } else {
          // dispatch(updateSaveProperty("Y"));
          setSavePropertyState(true);
          const response = await onSavePress({ propertyId });
          if (response === "success") {
            dispatch(showSavedTooltip(true));
            dispatch(setIsAddedToSaved());

            trackApiCall({
              eventName: "favourite_property_saved",
              eventCategory: "NEW-PDP",
              eventSource: "pdp_bid_center",
              eventLabel: `Property Id: ${propertyId}`,
            });
          } else {
            trackApiCall({
              eventName: "favourite_property_save_error",
              eventCategory: "Error",
              eventSource: `Error - ${
                response?.message || "Data Initialization Failed"
              }`,
              eventLabel: `Property Id: ${propertyId}`,
            });
          }
        }
      } else {
        // setShowModal(true);
        setShow(false)
        setTimeout(() => {
          setShowModal(true); // Open save modal after a brief delay
        }, 300);

        // handleClose()
        //  setShow(false);
      }
    };
    // const handleClose = () => {
    //   setShow(false);
    //   if (savePropertyState) {
    //     dispatch(updateSaveProperty("Y"))
    //   } else {
    //     dispatch(updateSaveProperty("N"))
    //   }
    // };
    useEffect(() => {
      if (pdpInitData?.propertySpecialDetails?.onWatchList === "Y") {
        setSavePropertyState(true)
      } else {
        setSavePropertyState(false)
      }
    }, [pdpInitData?.propertySpecialDetails?.onWatchList])
    useEffect(()=>{
 if (parseInt(bidAmount) < parseInt(auctionDetails?.nextpossibleBidAmount)) {
        setBidAmount(auctionDetails?.nextpossibleBidAmount);
      }
    },[auctionDetails])

  const renderBidCenterForActiveAuction = () => {
    return (
      <div style={{ height: 'auto' }}>
        {/* <h3 center style={{ margin: 10 }} className="propertyDetailsH1gallery">
          {fullAddress}
        </h3> */}
        <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>


        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>}
          {detailedAttributes?.squareFeet && parseInt(detailedAttributes.squareFeet.replace('Sq. Ft.', '')) > 0 && <div className="cols">
            <h4 className=" propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Sq.Ft.</p>
          </div>
          }
        </div>

        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
                   dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}>

          </div>

        {statusPayload.isActiveAuction && listingType === "AUCN" && (
          <>
            {auctionDetails?.auctionTimeLeft !== null &&
              auctionDetails?.auctionTimeLeft > 900 && (
                <div>

                  <div className="d-flex justify-content-between mt-5">
                    <p className="text-center bid-center-price-heading" style={{ width: "auto" }}>
                      {getPrice().label}
                    </p>
                    <h3 className="text-center bid-center-price-value" style={{ width: "auto" }}>
                      {getPrice().amount}
                    </h3>
                  </div>
                </div>
              )}
          </>
        )}
        <div>

          {auctionDetails?.auctionTimeLeft !== null &&
            auctionDetails?.auctionTimeLeft < 900 && (
              <div>
                <p className="text-center">
                  This auction has ended. Hubzu's system is currently processing
                  and sending all bid data to the seller for review. This page
                  will refresh when the property status is updated.
                </p>
              </div>
            )}

        </div>
        {
          (getPrice().label === "Starting Bid" || getPrice().label === "Current Highest Bid") && <div className="bid-start-gallery mt-2 mb-3">
            You can bid in ${getFormattedPrice(biddingIncrementalAmount)} increments.
          </div>
        }
        <Row xs={12} md={12} className="mt-2 g-2" >

          <Col xs={12} md={12}>

            <Col xs={12} md={12} className="d-flex align-items-start">

              <div
                className="bidAmountContainer w-100"


              >


                <button className="bidAmountContainerBtn col-md-2"


                  type="link"
                  onClick={decrement}
                >
                  <FaMinus />

                </button>

                <input className="col-md-8"
                  style={{
                    padding: 0,
                    border: 'none',
                    background: 'none',
                    textAlign: 'center',
                  }}
                  type="text"
                  aria-label="Bid amount"
                  defaultValue={'$' + getFormattedPrice(bidAmount)}
                  value={'$' + getFormattedPrice(bidAmount)}

                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^\d]/g, ""); // Remove non-digits
                    handleBidAmountChange(numericValue);
                  }}

                  // onChange={handleBidAmountChange}
                  maxLength={18}
                  onBlur={() => {

                    validateBidMinMaxPriceError();
                  }}
                />
                <button className="bidAmountContainerBtn col-md-2"


                  type=""

                  data-bs-toggle=""
                  onClick={increment}
                >

                  <FaPlus />
                </button>





              </div>
            </Col>
   {
                  validationError &&
                    <p style={{ color: 'red', fontSize: 12, paddingTop: 10 }}>{validationError}</p>

                }

          </Col>

          <Col xs={12} md={12}>
            <button
              className="btn btn-thm-bidCenter center end-auction col-12 p-2 mt-2"
              type=""
              onClick={() =>
                hanldePlaceBid("placeBid")
              }

            >
               {isVerificationGoing ? (
                  <LoadingText text="Processing..." />
                ) : (
                  <LoadedText text="Place Bid" />
                )}
              {/* Place Bid */}
            </button>
          </Col>
          {
            ownItNowEnabled &&
            bidCenterData?.ownitNowPrice !== "" &&
            bidCenterData?.ownitNowPrice !== 0 &&
            bidCenterData?.ownitNowPrice !== null &&
            bidCenterData?.ownitNowPrice !== "-" &&
              auctionDetails?.auctionTimeLeft !== null &&
          auctionDetails?.auctionTimeLeft > 900 && (
              <div className="pt-4">
                <div class="bid-divider" />
                <p className="bid-or">Or</p>

                <button
                  className="btn btn-thm-bidCenter center end-auction mb-0 p-2 mt-3"
                  type=""
                  onClick={() => handleOwnItNow()}
                >
                  {isVerificationGoingForOwnitNow ? (
                    <LoadingText text="Processing..." />
                  ) : (
                    <LoadedText text="End the Auction Now" />
                  )}
                </button>
                <p className="col-12 fz20 text-center end-aution-price-gallery">
                 For {"$" + getFormatPrice(bidCenterData?.ownitNowPrice)}
                </p>
              </div>
            )
          }
        </Row>

        {/* {ownItNowEnabled && bidCenterData?.ownitNowPrice !== '' && bidCenterData?.ownitNowPrice !== 0
                && bidCenterData?.ownitNowPrice !== null && bidCenterData?.ownitNowPrice !== '-' && (

                  <>
                    <br/>
                  <p className="col-12 fwb  fz16 text-center pt50">OR</p>
             <br/>
             <p className="col-12 fwb  fz16 text-center ">You can end the auction now for just</p>
             <p className="col-12 fwb fz20 text-center">{'$' +getFormatPrice(bidCenterData?.ownitNowPrice)}</p>
              <button
              className="btn btn-thm-bidCenter center col-12"
              type=""
              onClick={saveProperty}
            >
              End the Auction Now
            </button>

                  </>
                )} */}
                {
                  showNDA &&
                 <NDAModel
                        show={showNDA}
                         handleClose={() => setShowNDA(false)}

                        handleNDAccept={handleNDAccepted}
                        userProfileData={profileInfo}
                      />
                }
      </div>
    );
  };

  const renderBidCenterForWFAAuction = () => {
    return (
      <div style={{ height: 'auto' }}>
        {/* <h2 size={18} lh={26} className="text-center pb20" style={{ marginTop: 0 }}>
          {fullAddress}
        </h2> */}
          <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>

        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>}
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.")&& <div className="cols ml10 mr10">
            <h4 className=" propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Square Feet</p>
          </div>
          }
        </div>

        <div
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
                   dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}>

          </div>

        {/* <button
          className="btn btn-thm-bidCenter center col-12"
          type=""
          onClick={() =>
            saveProperty()
          }
        >
          Save This Property
        </button> */}
      </div>
    );
  };
  const renderBidCenterForWLST = () => {
    return (
      <div className="">
        {/* <h3 center style={{ margin: 10 }} className="propertyDetailsH1gallery">
          {fullAddress}
        </h3> */}
          <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>
        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>
          }
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.") && <div className="cols ml10 mr10">
            <h4 className=" propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Square Feet</p>
          </div>
          }
        </div>

        {/* <Row className="d-flex justify-content-between align-items-center">
          <p className="text-center">
            This listing is currently unavailable.
            <a
              href=""
              rel="noopener noreferrer"
              style={{ color: "#349beb", marginLeft: "5px" }}
            >
              Click here  {' '}
            </a>
            to browse properties nearby.
          </p>

        </Row> */}
        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
         dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}>

          </div>
      </div>
    );
  };
  const renderBidCenter = () => {
    return (
      <div>
        {/* <h3 center style={{ margin: 10 }} className="propertyDetailsH1gallery">
          {fullAddress}
        </h3> */}
  <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>

        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>
          }
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.")&& <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Square Feet</p>
          </div>
          }
        </div>

        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:"#000"
          }}
          dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}>

          </div>



        {isPreview && (
          <div style={{ marginTop: 20, marginBottom: 10 }}>
            {/* <button onPress={onSave}> */}
            <h1 active>
              {isSaved ? "Remove This Property" : "Save This Property"}
            </h1>
            {/* </button> */}
          </div>
        )}
        <div>

          {(bidCenterData.bestBidAvailable ||
            bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable) && (
              <div className="pt30">
                <button
                  className="btn btn-thm-bidCenter center col-12"
                  type=""
                  onClick={navigateToPlaceBackUpBid}
                >
                  {bidCenterData.bestBidAvailable && isSignedUser
                    ? "Place Best Bid"
                    : bidCenterData?.sellerFinalNegotiationResponse
                      ?.sellerFinalNegotiationAvailable
                      ? "Confirm Offer for $" +
                      getFormattedPrice(
                        bidCenterData?.sellerFinalNegotiationResponse
                          ?.solicitationAmount
                      )
                      : ""}
                </button>

              </div>
            )}

          {(isWatchProperty || statusPayload.isUpcoming) && (
            <div>
              <button onPress={isSaved ? gotoFavourite : onSave}>

                {isSaved ? "Go to Favorites" : "Add To Favorites"}

              </button>
            </div>
          )}
          {/*{status.isActive && !status.hasHnb === 'Y' && (*/}
          {statusPayload.isActive &&
            !isWatchProperty &&
            offerType !== "PLACE_BACKUP_OFFER" && (
              <div>

                <div>
                  {!statusPayload?.isTraditional && (
                    <>

                      <div>
                        <button onPress={isSaved ? gotoFavourite : onSave}>

                          Add To Favorites

                        </button>
                      </div>
                    </>
                  )}
                  {statusPayload.isTraditional &&
                    offerType !== "PLACE_OFFER" &&
                    offerType !== "WATCH_PROPERTY" && (
                      <></>
                    )}
                  {statusPayload.isTraditional && offerType === "PLACE_OFFER" && (

                    <></>

                  )}
                  {offerType !== "WATCH_PROPERTY" && (
                    <></>
                  )}
                </div>
                {/* {ownItNowEnabled &&
                  bidCenterData?.ownItNowPrice !== "" &&
                  bidCenterData?.ownItNowPrice !== 0 &&
                  bidCenterData?.ownItNowPrice !== null &&
                  bidCenterData?.ownItNowPrice !== "-" && (
                    <>
                      <div containerWidth={fullWidth}>
                        <div />
                        <p>or</p>
                        <div />
                      </div>
                      <div>
                        <button
                        // onPress={() => {
                        //   setOwnitNowClicked(true);
                        //   validateandContinue();
                        //   dispatch(updateIsOwnitnow(true));
                        // }}
                        >
                          <button active>
                            <h1 active ownitnow>
                              End the Auction Now
                            </h1>
                          </button>
                        </button>
                        <p>For ${getFormattedPrice(p)}</p>
                      </div>
                    </>
                  )} */}
                <p>{bidCenterData?.ownItNowPrice ? <p>{bidCenterData?.ownItNowPrice}</p> : null}</p>
              </div>
            )}
          {offerType !== "PLACE_OFFER" &&
            offerType !== "PLACE_BACKUP_OFFER" &&
            offerType !== "WATCH_PROPERTY" &&
            !isWatchProperty &&
            !bidCenterData.bestBidAvailable &&
            !bidCenterData?.sellerFinalNegotiationResponse
              ?.sellerFinalNegotiationAvailable &&
            (isUnderReviewAuction ||
              isUnderContractAuction ||
              statusPayload.hasHnb === "Y") &&
            latestBidCenterData.placeBackupBidButton === true && (

              <div className="pt30">
                <button
                  className="btn btn-thm-bidCenter center col-12"
                  type=""
                  onClick={() =>
                    hanldePlaceBid("placeBackupBid")
                  }
                >
                  {!statusPayload.isTraditional && "Place Backup Bid"}
                </button>

              </div>
              // </button>

            )}
          {offerType !== "PLACE_OFFER" &&
            !isWatchProperty &&
            statusPayload.isPreview && (
              //   <button onPress={isSaved ? gotoFavourite : onSave}>
              <div>

                <button
                  className="btn btn-thm-bidCenter center col-12"
                  type=""
                  onClick={saveTofav}
                >
                  {isSaved ? "Go to Favorites" : "Add To Favorites"}
                </button>
              </div>
              //   </button>
            )}
          {propCategory === "NPL" && (
            //   <button onPress={() => navigateToLeadForm()}>
            <div>
              <button
                className="btn btn-thm-bidCenter center col-12"
                type=""
                onClick={handleRequestInformation}
              >
                Request Information
              </button>

            </div>
            //   </button>
          )}
          {offerType === "PLACE_BACKUP_OFFER" && statusPayload.isTraditional && (
            //   <button onPress={() => navigateToPlaceBackUpOffer()}>
            <div>
              <button
                className="btn btn-thm-bidCenter center col-12"
                type=""
                onClick={() => navigateToPlaceBackUpOffer(offerCenterDetail?.listingId)}
              >

                Place Backup Offer
              </button>

            </div>
            //   </button>
          )}

          {countyBiddingEnabled === "Y" && (
            //   <button onPress={() => navigateToBidCountySite()}>
            <div>
              <button
                className="btn btn-thm-bidCenter center col-12"
                type=""
                onClick={navigateToBidCountySite}
              >
                Bid on County Site
              </button>

            </div>
            //   </button>
          )}
        </div>
      </div>
    );
  };
  // <div>

  const renderForeclosureView = () => {
    return(
     <div className="">
        {/* <h3 center style={{ margin: 10 }} className="propertyDetailsH1gallery">
          {fullAddress}
        </h3> */}
          <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>
        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>
          }
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.")&& <div className="cols ml10 mr10">
            <h4 className=" propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Square Feet</p>
          </div>
          }
        </div>

        {/* <Row className="d-flex justify-content-between align-items-center">
          <p className="text-center">
            This listing is currently unavailable.
            <a
              href=""
              rel="noopener noreferrer"
              style={{ color: "#349beb", marginLeft: "5px" }}
            >
              Click here  {' '}
            </a>
            to browse properties nearby.
          </p>

        </Row> */}
        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
         dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}>

          </div>
      </div>
    )

  }

  const renderBidCenterForCommercial = () => {
    return (
      <div style={{ height: 'auto' }}>
        {/* <h3 center style={{ margin: 10 }} className="propertyDetailsH1gallery">
          {fullAddress}
        </h3> */}
         <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>



        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>
          }
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.")&& <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Square Feet</p>
          </div>
          }
        </div>
        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
          dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}></div>


        {listingType === "AUCN" && (
          <>
            {bidCenterData?.auctionTimeLeft !== null &&
              bidCenterData?.auctionTimeLeft > 900 && (
                <div>
                  {/* <h3 className="text-center">AUCTION BEGINS IN</h3>
              <div className="d-flex justify-content-center">
                <CountdownTimer
                  until={latestBidCenterData?.auctionTimeLeft}
                />
              </div> */}
                  <div className="d-flex justify-content-between mt-5">
                    <p className="text-center bid-center-price-heading" style={{ width: "auto" }}>
                      {getPrice().label}
                    </p>
                    <h3 className="text-center bid-center-price-value" style={{ width: "auto" }}>
                      {getPrice().amount}
                    </h3>
                  </div>
                </div>
              )}
          </>
        )}
        <button
          className="btn btn-thm-bidCenter center col-12 reg-button"
          type=""
          onClick={() => hanldePlaceBid(pdpInitData?.cifCompleted
                  ? "registerCompleted"
                  : "registerToBid")}
        >
          {pdpInitData?.cifCompleted ? 'Registration Completed' : 'Register to Bid'}
        </button>
      </div>
    )
  }

  const renderPreviewBidCenter = () => {
    return (
      <div>
            <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>



        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds} </h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>
          }
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.")&& <div className="cols">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Sqaure Feet</p>
          </div>
          }
        </div>
        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
          >
            {detailedAttributes.description}
          </div>
        {/* <h2 className="text-center">PREVIEW PROPERTIES</h2>

        <div>

          <p className="text-left " style={{ width: "auto" }}>
            Stay ahead of the market with Hubzu's Preview Properties. Find out what properties are scheduled to come to our site, keep track of the perfect home and prepare to make a bid or offer.
          </p>
        </div>

        <button
          className="btn btn-thm-bidCenter center col-12"
          type=""
          onClick={() =>
            saveProperty()
          }
        >
          {pdpInitData?.onWatchList ? 'Remove This Property' : 'Save this property'}
        </button> */}
      </div>
    )
  }

  const renderOfferDetails = () => {
    return (

      <div>
        {/* <h3 center style={{ margin: 10 }} className="propertyDetailsH1gallery">
          {fullAddress}
        </h3> */}
         <h3 className="propertyDetailsH1gallery" style={{ margin: 0 }}>
          {fullAddress.split('\n')[0]}
        </h3>
        <p className="pdpGalleryline2" style={{ margin: 0, fontSize: '12px', color: '#666' }}>
          {fullAddress.split('\n')[1]}
        </p>

        <div className="mt15 mb20 align-items-center d-flex" >
          {beds && beds > 0 ? <div className="cols mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{beds}</h4>
            <p className="pdp-gallery-title  text-center mb0">Beds</p>
          </div> : <></>
          }
          {commonAttributes?.bathsNum > 0 ? <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{commonAttributes?.bathsNum}</h4>
            <p className="pdp-gallery-title text-center mb0">Baths</p>
          </div> : <></>
          }
          {detailedAttributes?.squareFeet && detailedAttributes?.squareFeet !== ("0 Sq. Ft.") && <div className="cols ml10 mr10">
            <h4 className="propertyDetailsH1gallery bold text-center mb0">{detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h4>
            <p className="pdp-gallery-title text-center mb0">Square Feet</p>
          </div>
          }
        </div>
        <div

          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.5em',
            maxHeight: '4.5em',
            color:'#000'
          }}
           dangerouslySetInnerHTML={{ __html: propCategory === "COMMERCIAL" ? pdpInitData?.propertyDetails?.shortDescription : detailedAttributes.description }}></div>

        {
          (offerCenterDetail?.hasHnB === "Y") &&
          offerCenterDetail?.remDeadlineHrs > 0 &&
          <>
            <h3 className="text-center bid-heading-ends-offer" style={{ width: "auto" }}>
              {getPrice().amount}
            </h3>
            <p className="text-center bid-center-price-heading " style={{ width: "auto" }}>
              {getPrice().label}
            </p>
          </>
        }
           {offerType === "PLACE_OFFER" && statusPayload.isTraditional && (
          <div className="d-flex justify-content-between mt-3">
            <p
              className="text-left bid-center-price-heading"
              style={{ width: "auto" }}
            >
              {getPrice().label}
            </p>
            <p
              className="text-right bid-center-price-data fwb propertyDetailsH1gallery"
              style={{ width: "auto" }}
            >
              {getPrice().amount}
            </p>
          </div>
        )}

        {(
          offerCenterDetail?.hasHnB === "Y") &&
          offerCenterDetail?.remDeadlineHrs > 0 &&
          <Col xs={12} md={12} className=" col d-flex justify-content-between align-items-center pt10">
            <p xs={6} md={6} className="text-left fwb bid-center-price-heading" >Listing Price:
              <Tooltip id="" style={{ width: 300 }} />
            </p>
            <p xs={6} md={6} className="text-right bid-center-price-data">{getFormatPrice(offerCenterDetail?.listingPrice)}</p>
          </Col>
        }



        {statusPayload.isTraditional && offerType === "PLACE_OFFER" && (
          <Row xs={12} md={12} className="pt10 mt-2">
            <Col xs={12} md={12} className=" align-items-start">
              <div
                className="bidAmountContainer">
                <input className="col-md-12"
                  style={{
                    padding: 0,
                    border: 'none',
                    background: 'none',
                    textAlign: 'center',
                    height: '45px'
                  }}
                  type="text"
                  aria-label="Offer amount"
                  defaultValue=""
                  value={redirectionAmount ? "$" + getFormattedPrice(redirectionAmount) : ""}
                  placeholder="Enter Your Offer"
                  onChange={handleOfferAmountChange}
                  maxLength={bidMaxLength}
                  onBlur={() => {

                    validateBidMinMaxPriceError();
                  }}
                />

              </div>
              {
                validationError ?
                  <p style={{ color: 'red', fontSize: 12, paddingTop: 5 }}>{validationError}</p>
                  : null
              }


            </Col>



            <Col xs={12} md={12}>
              <button
                className="btn btn-thm-bidCenter center col-12 p-2 mt-2"
                type=""
                onClick={placeOffer}
              >
                 {isVerificationGoing ? (
                                  <LoadingText text="Processing..." />
                                ) : (
                                  <LoadedText text="Place Offer" />
                                )}
              </button>
            </Col>

          </Row>
        )}
        {offerType === "PLACE_BACKUP_OFFER" && statusPayload.isTraditional && (
          //   <button onPress={() => navigateToPlaceBackUpOffer()}>
          <div>
            <button
              className="btn btn-thm-bidCenter center col-12 mt-4"
              type=""
              onClick={navigateToPlaceBackUpOffer}
            >
               {isVerificationGoing ? (
                  <LoadingText text="Processing..." />
                ) : (
                  <LoadedText text="Place Backup Offer" />
                )}
            </button>

          </div>
          //   </button>
        )}
                {offerCenterDetail?.hasHnB === "Y" &&
          offerType !== "PLACE_BACKUP_OFFER" &&
          offerType !== "PLACE_OFFER" && (
            <div>
              <button
                className={`btn btn-thm-bidCenter center p-2 mt10 dropdown ${savePropertyState ? 'previewPropertyWatch' : 'btn-bid-fav'}`}
                onClick={onSave}
                id="pdpAddSave"
              >
                {savePropertyState  ? "Remove from Favorites" : "Add To Favorites"}
              </button>
            </div>
          )}


 {showModal &&
          <Modal show={showModal} onHide={() => setShowModal(false)} >
            <PDPSaveModal showModal={showModal} setShowModal={setShowModal} isHideArrow={true} />

          </Modal>
        }
      </div>

    )

  }

  if (isForeclosure &&
    (commonAttributes?.status === 'SCHEDULED' || commonAttributes?.status === 'AUCTION_EVENT_ENDED' || commonAttributes?.status === 'CLEAR_TO_SALE') &&
    pdpInitData?.eventCenterDetail &&
    pdpInitData?.fcOnlineFlag !== 'Y' &&
    !pdpInitData?.fcProxyBidEnabled) {

    return renderForeclosureView()
  }


  if (listingType === "AUCN") {
    if (statusPayload.isActiveAuction === true) {
      return renderBidCenterForActiveAuction();
    } else if (status === "WFA") {
      return renderBidCenterForWFAAuction();
    } else if (status === 'PACT') {
      return renderBidCenterForCommercial();
    } else {

      return renderBidCenter();
    }
    return null;
  }

  else if (listingType === 'TRNL') {
    return renderOfferDetails()
  }

  else {
    if (listingType === null) {
      if (isPreview) {
        return renderPreviewBidCenter();
      }
      return renderBidCenterForWLST();

    } else {
      return renderBidCenter();
    }
  }

};

export default GalleryBidCenter;
